import { render, staticRenderFns } from "./indexModel.vue?vue&type=template&id=6b7e8e51"
import script from "./indexModel.vue?vue&type=script&lang=js"
export * from "./indexModel.vue?vue&type=script&lang=js"
import style0 from "./indexModel.vue?vue&type=style&index=0&id=6b7e8e51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports